import emojiMartData from '@emoji-mart/data/sets/14/twitter.json';
// Dual-format package: the browser resolves its ESM entry (named exports,
// no default) while node's SSR interop resolves its CJS entry (default
// only). A namespace import with a default-or-namespace destructure is the
// one form that works in both environments.
import * as emojiMartModule from 'emoji-mart';

const { SearchIndex, init } = emojiMartModule.default || emojiMartModule;

const EMOJI_VERSION = 14;
const EMOJI_SET = 'twitter';

const initEmojiData = () => {

	try {

		init({
			emojiVersion: EMOJI_VERSION,
			data: emojiMartData,
		});

	} catch (error) {
		console.error('initEmojiData: error initializing...');
		console.error(error);
	}

};

const getEmojiDataFromNative = async (character) => {

	// TODO: How to verify that this actually is a native code...

	try {

		const results = await SearchIndex.search(character);

		if (results && results[0]) {
			return results[0];
		}

	} catch (error) {
		console.error('getEmojiDataFromNative: error searching character...');
		console.error(error);
	}

	return null;

};

export {
	getEmojiDataFromNative,
	initEmojiData,
	emojiMartData as EMOJI_DATA,
	EMOJI_SET,
	EMOJI_VERSION,
};
